import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18next from "i18next";
import { ApiFortAgentActivateSign } from "@/api";
import {
  FortAgentActivateResultCode,
  type FortAgentActivateSignRequest,
} from "@/api/types";
import { showError } from "@/lib/toast";
import { getTokenName } from "@/config/common";
import { CCC_FUSD_ADDRESS, USDT_ADDRESS } from "@/config/env";

export function useFortAgentActivateSign() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: FortAgentActivateSignRequest) => {
      const res = await ApiFortAgentActivateSign(data);
      console.log("useFortAgentActivateSign", res.data);
      return res.data;
    },
    onSuccess: data => {
      const code = data.resultCode;
      if (code === FortAgentActivateResultCode.Success) {
        queryClient.invalidateQueries({ queryKey: ["myFortAgents"] });
        return;
      }
      showError(
        i18next.t(
          FORT_AGENT_ACTIVATE_RESULT_I18N_KEY[
            code as keyof typeof FORT_AGENT_ACTIVATE_RESULT_I18N_KEY
          ] ?? "toast.fortAgent.activate.result.unknown",
          {
            tokenName: getTokenName(CCC_FUSD_ADDRESS),
            tokenNameUsdt: getTokenName(USDT_ADDRESS),
          }
        )
      );
    },
    onError: error => {
      console.error("useFortAgentActivateSign error", error);
      showError(
        i18next.t("toast.fortAgent.activate.result.unknown", {
          tokenName: getTokenName(CCC_FUSD_ADDRESS),
          tokenNameUsdt: getTokenName(USDT_ADDRESS),
        })
      );
    },
  });
}

export const FORT_AGENT_ACTIVATE_RESULT_I18N_KEY: Record<
  Exclude<FortAgentActivateResultCode, FortAgentActivateResultCode.Success>,
  string
> = {
  [FortAgentActivateResultCode.WalletNotBound]:
    "toast.fortAgent.activate.result.walletNotBound",
  [FortAgentActivateResultCode.InvalidAgentId]:
    "toast.fortAgent.activate.result.invalidAgentId",
  [FortAgentActivateResultCode.NotOwnerOrAgentMissing]:
    "toast.fortAgent.activate.result.notOwnerOrAgentMissing",
  [FortAgentActivateResultCode.AlreadyActivated]:
    "toast.fortAgent.activate.result.alreadyActivated",
  [FortAgentActivateResultCode.SignServiceRejected]:
    "toast.fortAgent.activate.result.signServiceRejected",
  [FortAgentActivateResultCode.InsufficientFusd]:
    "toast.fortAgent.activate.result.insufficientFusd",
  [FortAgentActivateResultCode.PendingAgentOperation]:
    "toast.fortAgent.activate.result.pendingAgentOperation",
  [FortAgentActivateResultCode.OnlyOne]:
    "toast.fortAgent.activate.result.onlyOne",
  [FortAgentActivateResultCode.MixedFusdUnpaid]:
    "toast.fortAgent.activate.result.mixedFusdUnpaid",
  [FortAgentActivateResultCode.CustodyRewardAgentCannotActivate]:
    "toast.fortAgent.activate.result.custodyRewardAgentCannotActivate",
  [FortAgentActivateResultCode.CustodyRewardAgentBlocksActivation]:
    "toast.fortAgent.activate.result.custodyRewardAgentBlocksActivation",
};
